"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import classes from './styles.module.css.mjs';

const BASE_LEVEL = 1;
function NestedLevel({ level = BASE_LEVEL, children }) {
  if (level === BASE_LEVEL - 1) {
    return children;
  }
  return /* @__PURE__ */ jsx("div", { className: clsx(classes.nestedLevel), children: /* @__PURE__ */ jsx(NestedLevel, { level: level - 1, children }) });
}

export { NestedLevel };
